import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import BSNavbar from 'react-bootstrap/Navbar'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import InputGroup from 'react-bootstrap/InputGroup'
import { Link } from 'react-router-dom'
import Mana from './Mana'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { OutboundLink } from 'react-ga'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Settings from './Settings'
import Tooltip from 'react-bootstrap/Tooltip'
import Typeahead from './Typeahead'
import classNames from 'classnames'
import { fetchCommandersTypeahead } from '../store/typeahead'
import { fetchUrl } from '../util/helpers'
import logo from '../assets/logo.png'
import styles from '../styles/Navbar.module.scss'
import { toggleDecklist } from '../store/clipboard'
import useDarkMode from 'use-dark-mode'

const Navbar = () => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const auth = useSelector((state) => state.firebase.auth)
  const profile = useSelector((state) => state.firebase.profile)
  const [expanded, setExpanded] = useState(false)
  const [showSettings, setShowSettings] = useState(false)
  const cards = useSelector((state) => state.clipboard.cards)
  const commandersTypeahead = useSelector(
    (state) => state.typeahead.commandersTypeahead
  )
  const { pathname } = useLocation()
  const sets = useSelector((state) => state.misc.sets)
  const themes = useSelector((state) => state.misc.themes)
  const tribes = useSelector((state) => state.misc.tribes)

  useEffect(() => dispatch(fetchCommandersTypeahead()), [])

  useEffect(() => {
    setExpanded(false)
  }, [pathname])

  const navbarConfig = [
    {
      id: 'navbar-cards',
      submenu: [
        { href: '/top', value: 'Top Cards' },
        { href: '/top/salt', value: 'Saltiest Cards' },
        {
          id: 'navbar-cards-by-color',
          submenu: [
            { color: 'w', href: '/top/w', value: 'White' },
            { color: 'u', href: '/top/u', value: 'Blue' },
            { color: 'b', href: '/top/b', value: 'Black' },
            { color: 'r', href: '/top/r', value: 'Red' },
            { color: 'g', href: '/top/g', value: 'Green' },
            { color: 'c', href: '/top/colorless', value: 'Colorless' },
            { color: 'multi', href: '/top/multi', value: 'Multicolor' },
          ],
          title: 'By Color',
        },
        {
          id: 'navbar-cards-by-type',
          submenu: [
            { href: '/top/creatures', value: 'Creatures' },
            { href: '/top/instants', value: 'Instants' },
            { href: '/top/sorceries', value: 'Sorceries' },
            { href: '/top/artifacts', value: 'Artifacts' },
            {
              className: styles.indent,
              href: '/top/equipment',
              value: 'Equipment',
            },
            {
              className: styles.indent,
              href: '/top/utility-artifacts',
              value: 'Utility Artifacts',
            },
            {
              className: styles.indent,
              href: '/top/mana-artifacts',
              value: 'Mana Artifacts',
            },
            { href: '/top/enchantments', value: 'Enchantments' },
            { className: styles.indent, href: '/top/auras', value: 'Auras' },
            { href: '/top/planeswalkers', value: 'Planeswalkers' },
            { href: '/top/lands', value: 'Lands' },
            {
              className: styles.indent,
              href: '/top/utility-lands',
              value: 'Utility Lands',
            },
            {
              className: styles.indent,
              href: '/top/color-fixing-lands',
              value: 'Color-Fixing Lands',
            },
          ],
          title: 'By Type',
        },
        { href: '/combos', value: 'Combos' },
      ],
      title: 'Cards',
    },
    {
      id: 'navbar-commanders',
      submenu: [
        { href: '/commanders', value: 'Top Commanders' },
        { href: '/backgrounds', value: 'Backgrounds' },
        { href: '/partners', value: 'Partners' },
        {
          id: 'navbar-commanders-mono',
          submenu: [
            { color: 'w', href: '/commanders/w', value: 'White' },
            { color: 'u', href: '/commanders/u', value: 'Blue' },
            { color: 'b', href: '/commanders/b', value: 'Black' },
            { color: 'r', href: '/commanders/r', value: 'Red' },
            { color: 'g', href: '/commanders/g', value: 'Green' },
            { color: 'c', href: '/commanders/colorless', value: 'Colorless' },
          ],
          title: 'Mono',
        },
        {
          id: 'navbar-commanders-2-color',
          submenu: [
            { colors: 'wu', href: '/commanders/wu', value: 'Azorius' },
            { colors: 'ub', href: '/commanders/ub', value: 'Dimir' },
            { colors: 'br', href: '/commanders/br', value: 'Rakdos' },
            { colors: 'rg', href: '/commanders/rg', value: 'Gruul' },
            { colors: 'gw', href: '/commanders/gw', value: 'Selesnya' },
            { colors: 'wb', href: '/commanders/wb', value: 'Orzhov' },
            { colors: 'ur', href: '/commanders/ur', value: 'Izzet' },
            { colors: 'bg', href: '/commanders/bg', value: 'Golgari' },
            { colors: 'rw', href: '/commanders/rw', value: 'Boros' },
            { colors: 'gu', href: '/commanders/gu', value: 'Simic' },
          ],
          title: '2 Color',
        },
        {
          id: 'navbar-commanders-3-color',
          submenu: [
            { colors: 'wub', href: '/commanders/wub', value: 'Esper' },
            { colors: 'ubr', href: '/commanders/ubr', value: 'Grixis' },
            { colors: 'brg', href: '/commanders/brg', value: 'Jund' },
            { colors: 'rgw', href: '/commanders/rgw', value: 'Naya' },
            { colors: 'gwu', href: '/commanders/gwu', value: 'Bant' },
            { colors: 'wbg', href: '/commanders/wbg', value: 'Abzan' },
            { colors: 'urw', href: '/commanders/urw', value: 'Jeskai' },
            { colors: 'bgu', href: '/commanders/bgu', value: 'Sultai' },
            { colors: 'rwb', href: '/commanders/rwb', value: 'Mardu' },
            { colors: 'gur', href: '/commanders/gur', value: 'Temur' },
          ],
          title: '3 Color',
        },
        {
          id: 'navbar-commanders-4-5-color',
          submenu: [
            { colors: 'wubr', href: '/commanders/wubr', value: 'Yore-Tiller' },
            { colors: 'ubrg', href: '/commanders/ubrg', value: 'Glint-Eye' },
            { colors: 'brgw', href: '/commanders/brgw', value: 'Dune-Brood' },
            { colors: 'rgwu', href: '/commanders/rgwu', value: 'Ink-Treader' },
            { colors: 'gwub', href: '/commanders/gwub', value: 'Witch-Maw' },
            { colors: 'wubrg', href: '/commanders/wubrg', value: '5 Color' },
          ],
          title: '4+ Color',
        },
      ],
      title: 'Commanders',
    },
    {
      id: 'navbar-sets',
      submenu: [
        { href: '/sets', value: 'Sets' },
        ...sets.map(({ code, icon_svg_uri, name }) => ({
          className: styles.indent,
          code,
          href: `/sets/${code}`,
          icon_svg_uri,
          value: name,
        })),
        {
          className: styles.indentDouble,
          href: '/sets',
          value: 'More Sets...',
        },
        { href: '/precon', value: 'Precon Upgrades' },
      ],
      title: 'Sets',
    },
    {
      id: 'navbar-themes',
      submenu: [
        { href: '/companions', value: 'Companions' },
        { href: '/themes', value: 'Themes' },
        ...themes.map(({ key, name }) => ({
          className: styles.indent,
          href: `/themes/${key}`,
          value: name,
        })),
        { href: '/tribes', value: 'Tribes' },
        ...tribes.map((tribe) => ({
          className: styles.indent,
          href: `/tribes/${tribe.toLowerCase()}`,
          value: tribe,
        })),
      ],
      title: 'Themes',
    },
  ]

  const handleRandom = async () => {
    if (commandersTypeahead) {
      const i = Math.floor(Math.random() * commandersTypeahead.length)
      const random = commandersTypeahead[i]
      const url = await fetchUrl(random)
      navigate(url)
    } else {
      window.location.assign(`${window.origin}/random/`)
    }
  }

  const handleSearch = async (value) => {
    if (value.length > 0 && value[0].length > 0) {
      const url = await fetchUrl(value[0])
      navigate(url)
    }
  }

  return (
    <>
      <Settings
        handleClose={() => setShowSettings(false)}
        show={showSettings}
      />
      <BSNavbar
        bg='dark'
        className={classNames(
          styles.navbar,
          { [styles.dark]: darkMode.value },
          'shadow'
        )}
        expand='lg'
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
        variant='dark'
      >
        <BSNavbar.Brand>
          <Link to='/'>
            <img alt='EDHREC' className={styles.logo} src={logo} />
          </Link>
        </BSNavbar.Brand>
        <BSNavbar.Toggle />
        <BSNavbar.Collapse>
          <Nav className='mr-auto'>
            {navbarConfig.map(({ id, submenu, title }) => (
              <NavDropdown
                className={styles.dropdown}
                id={id}
                key={id}
                title={title}
              >
                {submenu.map(
                  ({
                    className,
                    href,
                    icon_svg_uri,
                    id,
                    submenu,
                    title,
                    value,
                  }) =>
                    submenu ? (
                      <NavDropdown id={id} key={id} title={title}>
                        {submenu.map(
                          ({ className, color, colors, href, value }) => (
                            <NavDropdown.Item
                              as={Link}
                              className={className}
                              key={href}
                              to={href}
                            >
                              <span className={styles.manaRow}>
                                {(colors
                                  ? [...colors]
                                  : color
                                  ? [color]
                                  : []
                                ).map((color) => (
                                  <Mana color={color} key={color} />
                                ))}
                                <span className={styles.text}>{value}</span>
                              </span>
                            </NavDropdown.Item>
                          )
                        )}
                      </NavDropdown>
                    ) : (
                      <NavDropdown.Item
                        as={Link}
                        className={className}
                        key={href}
                        to={href}
                      >
                        <span>
                          {icon_svg_uri && (
                            <img
                              className={styles.setIcon}
                              src={icon_svg_uri}
                            />
                          )}
                          {value}
                        </span>
                      </NavDropdown.Item>
                    )
                )}
              </NavDropdown>
            ))}
            <Nav.Link as={Link} to='/recs'>
              <FontAwesomeIcon className={styles.communityIcon} fixedWidth />
              Recs
            </Nav.Link>
          </Nav>
          <Nav className={styles.blah}>
            <div className={classNames(styles.buttonContainer, styles.onlyBig)}>
              <OverlayTrigger
                overlay={<Tooltip id='button-tooltip'>Clipboard</Tooltip>}
                placement='bottom'
              >
                <Button
                  className={styles.button}
                  onClick={() => dispatch(toggleDecklist())}
                  variant='light'
                >
                  <FontAwesomeIcon icon='paperclip' />{' '}
                  {Object.keys(cards).length}
                </Button>
              </OverlayTrigger>
            </div>
            <InputGroup className={styles.search}>
              <Typeahead
                clearOnChange
                onChange={handleSearch}
                placeholder='Search'
                showLoading
                spinner
              />
            </InputGroup>
            {auth.email ? (
              <div className={styles.buttonContainer}>
                <Button
                  as={Link}
                  className={classNames(styles.button, styles.displayName)}
                  to='/account'
                  variant='light'
                >
                  <FontAwesomeIcon
                    className={styles.communityIcon}
                    icon='user'
                  />
                  <span>{profile.displayName}</span>
                </Button>
              </div>
            ) : (
              <>
                <div className={styles.buttonContainer}>
                  <Button
                    as={Link}
                    className={styles.button}
                    to='/signin'
                    variant='light'
                  >
                    Sign In
                  </Button>
                  <Button
                    as={Link}
                    className={styles.button}
                    to='/signup'
                    variant='primary'
                  >
                    Sign Up
                  </Button>
                </div>
              </>
            )}
            <div
              className={classNames(styles.buttonContainer, styles.onlySmall)}
            >
              <Button
                className={styles.button}
                onClick={handleRandom}
                variant='light'
              >
                <FontAwesomeIcon icon='random' />
                {' Random'}
              </Button>
              <Button
                className={styles.button}
                onClick={() => setShowSettings(true)}
                variant='light'
              >
                <FontAwesomeIcon icon='gear' />
                {' Settings'}
              </Button>
            </div>
          </Nav>
        </BSNavbar.Collapse>
      </BSNavbar>
      <BSNavbar
        bg='dark'
        className={classNames(
          styles.navbar2,
          { [styles.dark]: darkMode.value },
          'shadow'
        )}
        variant='dark'
      >
        <Nav className='mr-auto'>
          <Nav.Link
            as={OutboundLink}
            className={styles.navbar2link}
            eventLabel='https://coalesceapparel.shop/discount/edhrec?redirect=/collections/edhrec/'
            rel='noopener noreferrer'
            target='_blank'
            to='https://coalesceapparel.shop/discount/edhrec?redirect=/collections/edhrec/'
          >
            <FontAwesomeIcon
              className={styles.communityIcon}
              fixedWidth
              icon='shirt'
            />
            Apparel
          </Nav.Link>
          <Nav.Link
            as={OutboundLink}
            className={styles.navbar2link}
            eventLabel='https://edhrec.com/articles'
            rel='noopener noreferrer'
            target='_blank'
            to='https://edhrec.com/articles'
          >
            <FontAwesomeIcon
              className={styles.communityIcon}
              fixedWidth
              icon='rss-square'
            />
            Articles
          </Nav.Link>
          <Nav.Link
            as={OutboundLink}
            className={styles.navbar2link}
            eventLabel='https://www.youtube.com/channel/UCApiDwDpn_JpzRGLZKrdr1g'
            rel='noopener noreferrer'
            target='_blank'
            to='https://www.youtube.com/channel/UCApiDwDpn_JpzRGLZKrdr1g'
          >
            <FontAwesomeIcon
              className={styles.communityIcon}
              fixedWidth
              icon='podcast'
            />
            EDHRECast
          </Nav.Link>
          <Nav.Link
            as={Link}
            className={styles.navbar2link}
            eventLabel='https://edhrec.com/faq'
            to='/faq'
          >
            <FontAwesomeIcon
              className={styles.communityIcon}
              fixedWidth
              icon='question'
            />
            FAQ
          </Nav.Link>
          <Nav.Link
            as={OutboundLink}
            className={styles.navbar2link}
            eventLabel='https://www.youtube.com/channel/UCApiDwDpn_JpzRGLZKrdr1g'
            rel='noopener noreferrer'
            target='_blank'
            to='https://www.youtube.com/channel/UCApiDwDpn_JpzRGLZKrdr1g'
          >
            <FontAwesomeIcon
              className={styles.communityIcon}
              fixedWidth
              icon={['fab', 'patreon']}
            />
            Patreon
          </Nav.Link>
        </Nav>
        <Nav className={styles.blarg}>
          <div className={styles.buttonContainer}>
            <OverlayTrigger
              overlay={<Tooltip id='button-tooltip'>Random</Tooltip>}
              placement='bottom'
            >
              <Button
                className={styles.button}
                onClick={handleRandom}
                size='sm'
                variant='dark'
              >
                <FontAwesomeIcon icon='random' />
              </Button>
            </OverlayTrigger>
          </div>
          <div className={styles.buttonContainer}>
            <OverlayTrigger
              overlay={<Tooltip id='button-tooltip'>Contact us</Tooltip>}
              placement='bottom'
            >
              <Link to='/contact-us'>
                <Button className={styles.button} size='sm' variant='dark'>
                  <FontAwesomeIcon icon='envelope' />
                </Button>
              </Link>
            </OverlayTrigger>
          </div>
          <div className={styles.buttonContainer}>
            <OverlayTrigger
              overlay={<Tooltip id='button-tooltip'>Settings</Tooltip>}
              placement='bottom'
            >
              <Button
                className={styles.button}
                onClick={() => setShowSettings(true)}
                size='sm'
                variant='dark'
              >
                <FontAwesomeIcon icon='cog' />
              </Button>
            </OverlayTrigger>
          </div>
          <span>&nbsp;</span>
        </Nav>
      </BSNavbar>
    </>
  )
}

export default Navbar
